import React, { useState, useEffect } from 'react';
import { useLanguage } from './i18n/LanguageContext';
import { useUserLanguage } from './i18n/UserLanguageContext';
import { getStarterItems } from './data/vocabPool';
import './LunaLoader.css';

// A friendly waiting screen: Gabi bounces, the message changes every few seconds,
// and a word from the language being learned is shown to read while waiting.
// Nothing here calls an API, so it costs nothing.

const MESSAGES = {
    lesson: {
        en: ['Gabi is preparing your lesson...', 'Picking the right words for your level...', 'Almost ready...'],
        it: ['Gabi sta preparando la tua lezione...', 'Scelgo le parole giuste per il tuo livello...', 'Ci siamo quasi...'],
        es: ['Gabi está preparando tu lección...', 'Eligiendo las palabras adecuadas para tu nivel...', 'Ya casi está...'],
        fr: ['Gabi prépare ta leçon...', 'Je choisis les bons mots pour ton niveau...', 'C’est presque prêt...'],
        pt: ['A Gabi está preparando sua lição...', 'Escolhendo as palavras certas para o seu nível...', 'Quase lá...'],
    },
    story: {
        en: ['Gabi is writing your story...', 'Choosing the right words for your level...', 'Almost ready...'],
        it: ['Gabi sta scrivendo la tua storia...', 'Scelgo le parole giuste per il tuo livello...', 'Ci siamo quasi...'],
        es: ['Gabi está escribiendo tu historia...', 'Eligiendo las palabras adecuadas para tu nivel...', 'Ya casi está...'],
        fr: ['Gabi écrit ton histoire...', 'Je choisis les bons mots pour ton niveau...', 'C’est presque prêt...'],
        pt: ['A Gabi está escrevendo sua história...', 'Escolhendo as palavras certas para o seu nível...', 'Quase lá...'],
    },
};

const WHILE_YOU_WAIT = {
    en: 'While you wait',
    it: 'Nell’attesa',
    es: 'Mientras esperas',
    fr: 'Pendant que tu attends',
    pt: 'Enquanto você espera',
};

export default function LunaLoader({ kind }) {
    const { interfaceLanguage } = useLanguage();
    const { activeLanguage } = useUserLanguage();
    const uiLang = MESSAGES.lesson[interfaceLanguage] ? interfaceLanguage : 'en';
    const targetLang = (activeLanguage || localStorage.getItem('vozoly_target_language') || 'italian').toLowerCase();

    const messages = (MESSAGES[kind] || MESSAGES.lesson)[uiLang];
    const [words] = useState(() => {
        const items = getStarterItems(targetLang, uiLang);
        const copy = [...items];
        for (let i = copy.length - 1; i > 0; i -= 1) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    });
    const [messageIndex, setMessageIndex] = useState(0);
    const [wordIndex, setWordIndex] = useState(0);

    useEffect(() => {
        const messageTimer = setInterval(() => setMessageIndex(i => Math.min(i + 1, messages.length - 1)), 5000);
        const wordTimer = setInterval(() => setWordIndex(i => (i + 1) % words.length), 3500);
        return () => {
            clearInterval(messageTimer);
            clearInterval(wordTimer);
        };
    }, [messages.length, words.length]);

    const word = words[wordIndex];

    return (
        <div className="luna-loader">
            <div className="luna-loader-stage">
                <span className="luna-star s1">✦</span>
                <span className="luna-star s2">✦</span>
                <span className="luna-star s3">✦</span>
                <div className="luna-loader-avatar">🦉</div>
                <div className="luna-loader-shadow"></div>
            </div>
            <div className="luna-loader-message">{messages[messageIndex]}</div>
            {word && (
                <div className="luna-loader-word" key={wordIndex}>
                    <div className="luna-loader-label">{WHILE_YOU_WAIT[uiLang]}</div>
                    <div className="luna-loader-target">{word.word}</div>
                    {word.translation && <div className="luna-loader-translation">{word.translation}</div>}
                </div>
            )}
        </div>
    );
}